import {
	Component,
	OnInit,
	Renderer2,
	HostListener,
	ViewChild,
	ElementRef,
	AfterViewInit,
} from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import { Meta, Title } from '@angular/platform-browser';
import {
	FormControl,
	FormGroup,
	FormBuilder,
	Validators,
} from '@angular/forms';
declare var $: any;
// Services
import { PageService } from '../providers/page/page.service';

import { HttpClient } from '@angular/common/http';
import { ProjectService } from '../providers/project/project.service';
import {
	ModalDismissReasons,
	NgbModal,
	NgbActiveModal,
} from '@ng-bootstrap/ng-bootstrap';
import { LazyLoaderService } from '../services/lazy-loader.service';
 
// import { SpinalThreeService } from '../providers/SplineThree/spinal-three.service';

@Component({
	selector: 'app-studio',
	templateUrl: './studio.component.html',
	styleUrls: ['./studio.component.scss'],
})
export class StudioComponent implements OnInit {
	baseUrl: any;
	imagepath: any;
	currentPage: number = 1;
	allprojects: any = [];
	currentLimit: number = 4;
	// desktopslider: OwlOptions = {
	// 	loop: false,
	// 	rewind: true,
	// 	autoplay: true,
	// 	autoplayTimeout: 15000,
	// 	center: true,
	// 	dots: true,
	// 	autoHeight: true,
	// 	autoWidth: true,
	// 	// animateOut: 'fadeOut',
	// 	// animateIn: 'fadeIn',
	// 	smartSpeed: 1,
	// 	responsive: {
	// 		0: {
	// 			items: 1,
	// 		},
	// 		600: {
	// 			items: 1,
	// 		},
	// 		1000: {
	// 			items: 1,
	// 		}
	// 	}
	// }
	spline: any;
	// isScroll: any;
	// @HostListener('window:scroll', ['$event'])
	// onScroll(event: Event): void {
	// 	const section3 = document.getElementById('section3');
	// 	const section4 = document.getElementById('sixth');
	// 	const rect = section3?.getBoundingClientRect();
	// 	const rect1 = section4?.getBoundingClientRect();
	// 	const wins = window.scrollY;
	// 	// console.log('windows'+ wins);
	// 	console.log('rect - ' + rect.top);
	// 	console.log('rect1 - ' + rect1.top);
	// 	// console.log('bootom - '+ rect.bottom);
	// 	if (rect && !rect1) {
	// 		$('#section3').addClass('sticky');
	// 		this.isScroll = true;
	// 	} else if (rect1 && rect.top <= 1) {
	// 		$('#section3').removeClass('sticky');
	// 	} else {
	// 		$('#section3').addClass('sticky');
	// 	}
	// }
	// @ViewChild('targetSection') targetSection!: ElementRef;
	// @ViewChild('lastSection') lastSection!: ElementRef;
	@ViewChild('canvas', { static: true })
	containerRef!: ElementRef<HTMLDivElement>;
	constructor(
		private renderer: Renderer2,
		private pageservice: PageService,
		private metaTagService: Meta,
		private titleService: Title,
		private lazyLoader: LazyLoaderService,

		// private splineThreeService: SpinalThreeService,
		private formBuilder: FormBuilder,
		private readonly http: HttpClient,
		private projectservice: ProjectService,
		private modalService: NgbModal,
		private activeModal: NgbActiveModal
	) {
		this.baseUrl = environment.baseUrl + '/assets';
		this.imagepath = environment.backendUrl + '/public/';
		this.get_PageMeta();
		this.get_AllProjects();
	}

	ngOnInit(): void {
		// window.scroll(0,0);
		// const canvas = document.getElementById('canvas') as HTMLCanvasElement;
		// this.spline = new Application(canvas);
		// this.spline.load(
		// 	'https://prod.spline.design/9TkLX7Ik6tbNUBSS/scene.splinecode'
		// );
		// if (this.containerRef && this.containerRef.nativeElement) {
		// 	const container = this.containerRef.nativeElement;
		// 	this.splineThreeService.initialize(
		// 		container,
		// 		'https://prod.spline.design/9TkLX7Ik6tbNUBSS/scene.splinecode'
		// 	);
		// }
		setTimeout(() => {
			window.scroll({
				top: 0,
				left: 0,
				behavior: 'smooth',
			});
		}, 500);
		// setTimeout(() => {
		//   const canvas = document.getElementById('canvas') as HTMLCanvasElement;
		//   this.spline = new Application(canvas);
		//   this.spline.load('https://prod.spline.design/ETc1NgtkFiSuPoFT/scene.splinecode');
		// }, 500);
	}

	ngAfterViewInit() {
		
this.lazyLoader.loadScript('https://unpkg.com/@splinetool/viewer/build/spline-viewer.js')
.then(() => console.log('Spline viewer loaded'))
.catch(() => console.error('Failed to load spline viewer script'));
		// 	const observer = new IntersectionObserver(
		// 		(entries) => {
		// 			entries.forEach(entry => {
		// 				if (entry.isIntersecting) {
		// 					setTimeout(() => {
		// 						$('#section3').addClass('sticky');
		// 					}, 200);
		// 				}
		// 			});
		// 		},
		// 		{ threshold: 0.1 } // Adjust threshold for when you want the callback to trigger
		// 	);

		// 	observer.observe(this.targetSection.nativeElement);

		// 	const observer2 = new IntersectionObserver(
		// 		(entries) => {
		// 			entries.forEach(entry => {
		// 				if (entry.isIntersecting) {
		// 					setTimeout(() => {
		// 						// $('#section3').removeClass('sticky');
		// 					}, 200);
		// 				}
		// 			});
		// 		},
		// 		{ threshold: 0.1 } // Adjust threshold for when you want the callback to trigger
		// 	);

		// 	observer2.observe(this.lastSection.nativeElement);
		
	}

	get_PageMeta() {
		let obj = { pageName: 'studio' };
		this.pageservice.getpageWithName(obj).subscribe((response) => {
			if (response.body.code == 200) {
				this.titleService.setTitle(response?.body.result.meta_title);
				// this.metaTagService.addTags([
				// 	{ name: 'description', content: response?.body.result.meta_description },
				// 	{ name: 'keywords', content: response?.body.result.meta_keywords },
				// ]);
				this.metaTagService.updateTag({
					name: 'description',
					content: response?.body.result.meta_description,
				});
				this.metaTagService.updateTag({
					name: 'keywords',
					content: response?.body.result.meta_keywords,
				});
				this.metaTagService.updateTag({
					rel: 'canonical',
					href: 'https://www.pixtar.ae/studio',
				});
			} else if (response.body.code == 400) {
			} else {
			}
		});
	}
	get_AllProjects() {
		const obj = {
			limit: this.currentLimit,
			page: this.currentPage,
		};
		this.projectservice.getAllProjects(obj).subscribe((response) => {
			if (response.code == 200) {
				if (response.result && response.result.length > 0) {
					response.result.forEach((project) => {
						if (project.status) {
							this.allprojects.push(project);
						}
					});
				}
			} else if (response.code == 400) {
			} else {
			}
		});
	}

	loadMore() {
		this.currentLimit = this.currentLimit + 4;
		this.get_AllProjects();
	}
	// sliderInterval: any;
	// stopSlider(): void {
	// 	if (this.sliderInterval) {
	// 		clearInterval(this.sliderInterval); // Clears the interval
	// 		// console.log('Slider stopped');
	// 	}
	// }

	// onMouseLeave() {
	// 	// clearInterval(this.interval);
	// 	if (this.sliderInterval) {
	// 		clearInterval(this.sliderInterval); // Clears the interval
	// 		console.log('Slider stopped');
	// 	}
	// }

	// onMouseEnter(index: number): void {

	// 	let projectname = this.allprojects[index];
	// 	let images = projectname.project_images;
	// 	let url = this.imagepath;
	// 	let img = document.getElementsByClassName('galleryimg' + index);

	// 	// Function to update the images
	// 	this.sliderInterval = setInterval(() => {
	// 		// setInterval(function () {
	// 		$(img).each(function (index) {
	// 			let newImage = images[(index + Math.floor(Math.random() * images.length)) % images.length];
	// 			$(img).attr('src', url + newImage); // Set new image source
	// 		});
	// 	}, 900); // Update every 3 seconds
	// 	// console.log(`Mouse entered image at index: ${index}`);
	// }
}
